import { apiWithHeader } from "./api";
import { BASE_URL } from "./environment";
import { API_STATUS, LOGIN_URL } from "./apiUrl";
import Utils from "../utility/utility";
import { hasAuthToken, missingTokenError, normalizeApiError } from "./apiError";

// The only endpoint reached without a session.
const PUBLIC_URLS = [LOGIN_URL];

export const postApiCall = async (params, access_token, url, isFormData=false) => {
  const CONTENT_TYPE = "application/json";

  /* Without this the app kept calling the API with `Authorization: Basic` and
     every screen on the page collected a 401 "Wrong authorization header
     format" - the dashboard sat empty and the notification poll repeated it
     every 10s. A blank token is not a server problem, it is a dead session. */
  if (!PUBLIC_URLS.includes(url) && !hasAuthToken(access_token)) {
    return Promise.reject(missingTokenError());
  }

  const response = await apiWithHeader(BASE_URL, CONTENT_TYPE, access_token,isFormData)
    .post(url, params)
    .catch(function (error) {
      // Utils.toast("error", error?.response?.data?.message);
      // axios has no `response` when the request never reached the server
      // (offline, DNS, CORS, or the 10s timeout). Callers all read
      // `error?.data?.message`, so hand them that shape either way —
      // otherwise the failure is swallowed and the screen just sits there.
      return Promise.reject(normalizeApiError(error));
    });

  if (response?.data?.status === API_STATUS.SUCCESS) {
    if (params.showSuccessToast === true) {
    
      Utils.toast("success", response?.data?.message);
    }
    return response?.data?.data;
  } else {
    return Promise.reject(response);
  }
};

export const postApiCallImage = async (formData, url) => {
  const CONTENT_TYPE = "multipart/form-data";
  return apiWithHeader(BASE_URL, CONTENT_TYPE)
    .post(url, formData)
    .catch(function (error) {
      return error.response;
    });
};
